import { Alert } from "PFComponents/alert";
import DataTable, { DataTableColumn, Warning } from "PFComponents/data_table/data_table";
import React, { ReactNode } from "react";

type PermissionsSectionProps<DATA> = {
  title: string;
  description: string;
  qaId: string;
  columns: DataTableColumn[];
  errors: string | undefined;
  warnings?: Warning[];
  data: DATA[];
  renderFocusRow?: (row: DATA) => ReactNode;
};

export const PermissionsSection = <DATA extends object>({
  qaId,
  title,
  description,
  columns,
  data,
  errors,
  warnings,
  renderFocusRow
}: PermissionsSectionProps<DATA>): JSX.Element => (
  <>
    <h2 style={{ marginTop: 50 }}>{title}</h2>
    <p style={{ marginBottom: 30 }}>{description}</p>
    {errors && <Alert kind="error" title={errors} style={{ marginBottom: 20 }} />}
    <DataTable
      qaId={qaId}
      columns={columns}
      data={data}
      warnings={warnings}
      renderFocusRow={renderFocusRow}
    />
  </>
);
